import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type PhoneOffIconProps = {
  size?: number
  color?: string
  colorScheme?: 'dark' | 'light'
  className?: string
}

export const PhoneOffIcon = ({
  size = 20,
  color,
  colorScheme = 'dark',
  className,
}: PhoneOffIconProps) => {
  const resolvedColor =
    color ??
    (colorScheme === 'light'
      ? tokenVar('colors.light.icon.secondary')
      : tokenVar('colors.icon.secondary'))
  return (
    <svg
      aria-label='Phone off'
      className={className}
      fill='none'
      height={size}
      role='img'
      viewBox='0 0 20 20'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#phone-off-clip)'>
        <path
          d='M4.32467 10.6749C2.92122 8.51075 2.04497 6.04756 1.76634 3.48325C1.74552 3.25281 1.7729 3.02055 1.84676 2.80127C1.92061 2.58199 2.03932 2.38049 2.19531 2.2096C2.35131 2.03871 2.54118 1.90218 2.75283 1.80869C2.96449 1.7152 3.19329 1.6668 3.42467 1.66659H5.92467C6.3291 1.6626 6.72117 1.80582 7.02781 2.06953C7.33445 2.33324 7.53474 2.69946 7.59134 3.09992C7.69686 3.89997 7.89255 4.68552 8.17468 5.44159C8.28679 5.73986 8.31106 6.06401 8.2446 6.37565C8.17813 6.68729 8.02373 6.97334 7.79967 7.19992L6.74134 8.25825M19.1663 0.833252L0.833008 19.1666M8.89968 11.0916C9.74539 11.938 10.7012 12.6668 11.7413 13.2583L12.7997 12.1999C13.0262 11.9759 13.3123 11.8215 13.6239 11.755C13.9356 11.6885 14.2597 11.7128 14.558 11.8249C15.3141 12.107 16.0996 12.3027 16.8997 12.4083C17.3001 12.4649 17.6664 12.6651 17.9301 12.9718C18.1938 13.2784 18.337 13.6705 18.333 14.0749V16.5749C18.334 16.807 18.2864 17.0367 18.1934 17.2494C18.1005 17.462 17.9641 17.6529 17.7931 17.8098C17.6221 17.9667 17.4202 18.0862 17.2003 18.1605C16.9804 18.2349 16.7475 18.2625 16.5163 18.2416C13.952 17.963 11.4888 17.0867 9.32467 15.6833C8.32073 15.0458 7.39011 14.2996 6.54967 13.4583L8.89968 11.0916Z'
          stroke={resolvedColor}
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth={1.5}
        />
      </g>
      <defs>
        <clipPath id='phone-off-clip'>
          <rect fill='white' height='20' width='20' />
        </clipPath>
      </defs>
    </svg>
  )
}
